<template>
  <div class="map-wrapper">
    <div id="map" ref="mapContainer"></div>

    <div class="loader" ref="loader">
      <div class="loader__spinner"></div>
      <div class="loader__text">Загрузка...</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  address: { type: String, required: true },
});

const mapContainer = ref(null);
const loader = ref(null);

function showLoader(message = 'Загрузка...') {
  if (!loader.value) return;
  loader.value.querySelector('.loader__text').textContent = message;
  loader.value.style.display = 'flex';
}

function hideLoader() {
  if (!loader.value) return;
  loader.value.style.display = 'none';
}

window.buildRoute = function(lat, lng) {
  showLoader('Определяем ваше местоположение...');

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(pos => {
      const myLat = pos.coords.latitude;
      const myLng = pos.coords.longitude;
      hideLoader();

      const url = `yandexnavi://build_route_on_map?lat_from=${myLat}&lon_from=${myLng}&lat_to=${lat}&lon_to=${lng}`;

      if (!/Android|iPhone|iPad/i.test(navigator.userAgent)) {
        window.open(`https://yandex.ru/maps/?rtext=${myLat},${myLng}~${lat},${lng}&rtt=auto`, '_blank');
      } else {
        window.location.href = url;
      }
    }, () => {
      hideLoader();
      alert('Не удалось определить текущее местоположение');
    });
  } else {
    hideLoader();
    alert('Геолокация не поддерживается вашим браузером');
  }
};

function addMyLocation(map) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(pos => {
      const myCoords = [pos.coords.latitude, pos.coords.longitude];
      const myPlacemark = new ymaps.Placemark(myCoords, {
        balloonContent: 'Вы здесь'
      }, {
        preset: 'islands#blueCircleDotIcon',
        draggable: false
      });
      map.geoObjects.add(myPlacemark);
      hideLoader();
    }, () => {
      hideLoader();
      alert('Не удалось определить ваше местоположение');
    });
  } else {
    hideLoader();
    alert('Геолокация не поддерживается вашим браузером');
  }
}

async function fetchCoords(address) {
  showLoader('Определяем координаты адреса...');
  const res = await fetch(`/map/coords?address=${encodeURIComponent(address)}`);
  if (!res.ok) throw new Error('coords not found');
  const data = await res.json();
  hideLoader();
  return {
    coords: data.coords,
    name: decodeURIComponent(data.name)
  };
}

async function initMap() {
  showLoader('Загрузка карты...');

  const location = await fetchCoords(props.address);
  const locations = [location];

  if (!window.ymaps) {
    const script = document.createElement('script');
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${import.meta.env.VITE_YANDEX_API_KEY}&lang=ru_RU`;
    script.async = true;
    document.head.appendChild(script);

    await new Promise(resolve => {
      script.onload = resolve;
    });
  }

  ymaps.ready(() => {
    const centerCoords = locations[0].coords;
    const map = new ymaps.Map("map", { center: centerCoords, zoom: 10 });

    const MyBalloonLayout = ymaps.templateLayoutFactory.createClass(`
      <div class="my-balloon" style="min-width:200px; font-family: Arial; padding: 10px;">
        <h3 style="margin-top:0;">$[properties.name]</h3>
        <button style="margin:5px 0; padding:5px 10px; background:#2196F3; color:white; border:none; cursor:pointer;"
          onclick="buildRoute($[properties.lat], $[properties.lng])">Построить маршрут</button>
      </div>
    `);

    locations.forEach(item => {
      const placemark = new ymaps.Placemark(item.coords, {
        name: item.name,
        lat: item.coords[0],
        lng: item.coords[1]
      }, {
        balloonContentLayout: MyBalloonLayout
      });
      map.geoObjects.add(placemark);
    });

    addMyLocation(map);
    hideLoader();
  });
}

onMounted(initMap);
</script>

<style scoped lang="scss">
#map { width: 100%; height: 500px; }

.loader {
  position: fixed;
  inset: 0;
  background: rgba(255,255,255,.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  &__spinner {
    border: 4px solid #f3f3f3;
    border-top-color: #2196f3;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  &__text { margin-left: 10px; }
}
@keyframes spin { to { transform: rotate(360deg); } }
.my-balloon button { cursor: pointer; }
</style>
